import React, { PropTypes } from 'react';
import { FormActions, FormBody, SelectInput, TextInput } from "../../../Form";
import { inject, observer } from 'mobx-react';
import { observable, action, extendObservable } from 'mobx';
import Form from "../../../Form";
import { smtpConfig as api } from "../../api";

@inject('userStore')
@observer
export default class EmailSetup extends React.Component {

  static contextTypes = {
    notify: PropTypes.object.isRequired,
    router: PropTypes.shape().isRequired,
  };

  @observable item = {
    type: '',
    server: '',
    username: '',
    pass: '',
    display_name: '',
    email: '',
    support_email: '',
    support_user_id: '',
  };

  componentWillMount() {
    const { userStore } = this.props;
    if (!userStore.isLoading && !userStore.items.length) userStore.fetchItems();
    api.fetch().then(json => {
      if (!!json) this.item = extendObservable({}, json, {
        pass: json.pass || '',
        support_email: json.support_email || '',
        support_user_id: json.support_user_id || ''
      });
    }).catch(console.error);
  }

  @action onChangeField = (field, e) => this.item[field] = e.target.value;

  onSave = e => {
    e.preventDefault();
    const { notify } = this.context;
    api.create(this.item).then(notify.success).catch(notify.error)
  };

  onTest = e => {
    e.preventDefault();
    this.context.router.push('/monitoring/config/email/test');
  }

  render() {
    const { userStore } = this.props;

    return (
      <div>
        <Form>
          <FormBody>
            <TextInput label={'Type'} value={this.item.type} onChange={e => this.onChangeField('type', e)} />
            <TextInput label={'Server'} value={this.item.server} onChange={e => this.onChangeField('server', e)} />
            <TextInput label={'Username'} value={this.item.username} onChange={e => this.onChangeField('username', e)} />
            <TextInput type={'password'} label={'Password'} value={this.item.pass} onChange={e => this.onChangeField('pass', e)} />
            <TextInput label={'Display Name'} value={this.item.display_name} onChange={e => this.onChangeField('display_name', e)} />
            <TextInput label={'Email'} value={this.item.email} onChange={e => this.onChangeField('email', e)} />
            <SelectInput
              label={'Support User'}
              value={this.item.support_user_id}
              onChange={e => {
                const user = userStore.findById(+e.target.value);
                this.onChangeField('support_user_id', e);
                this.onChangeField('support_email', { target: { value: user.email } });
              }}
              options={userStore.items}
              fields={{
                label: 'name',
                value: 'id',
              }}
            />
          </FormBody>
          <FormActions>
            <button onClick={this.onSave}>Save</button>
            <button onClick={this.onTest}>Test</button>
          </FormActions>
        </Form>
        {this.props.children}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/Email/EmailSetup.js